import { filesize } from 'filesize';

export const roundToNDecimals = (value: number, decimals: number): number => {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

export const roundToOneDecimal = (value: number): number => roundToNDecimals(value, 1);
export const roundToTwoDecimals = (value: number): number => {
  if (!Number.isFinite(value)) {
    return NaN;
  }
  // Shift décimal via toFixed pour à la fois éviter la perte IEEE 754 et la notation scientifique
  // Ex normal : 9494.075 * 100 = 949407.4999... (faux IEEE), .toFixed(10) = '949407.5000000000' (juste)
  // Ex tiny : 3.23e-14 * 100 = 3.23e-12, .toFixed(10) = '0.0000000000' (juste, pas NaN)
  const shifted = Number((value * 100).toFixed(10));
  const floored = Math.floor(shifted);
  const remainder = shifted - floored;

  // Normalise -0 → 0 (toFixed produit `-0.0000000000` pour des entrées comme -3.23e-14)
  if (Math.abs(remainder - 0.5) > 1e-8) {
    const rounded = Math.round(shifted);
    return rounded === 0 ? 0 : rounded / 100;
  }

  // HALF_EVEN (banker's rounding) : .5 arrondi vers le pair le plus proche
  // Aligné sur le comportement Joda-Money HALF_EVEN du backend Scala
  const rounded = floored % 2 === 0 ? floored : floored + 1;
  return rounded === 0 ? 0 : rounded / 100;
};

export const formatFileSize = (size: number): string =>
  filesize(size, {
    symbols: { B: 'o', MB: 'Mo', kB: 'ko' },
    base: 10,
    separator: ',',
  });

export const formatNumber = (value: number): string => value.toLocaleString().replace(/\s/g, '');

export const formatCurrency = (value: number): string => {
  const isInt = value % 1 === 0;

  if (isInt) {
    return `${value.toLocaleString('fr-FR')} €`;
  }

  return (Math.round(value * 100) / 100).toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  });
};

export const capitalize = (str: string): string =>
  `${str.slice(0, 1).toUpperCase()}${str.slice(1)}`;

export const truncate = (str: string, maxLength: number): string =>
  `${str.slice(0, maxLength).trim()}${str.length > maxLength ? '...' : ''}`;
